<template>
  <div class="SearchWrap">
    <i class="iconfont icon-fanhui back" @click="back()" v-if="middle"/>
    <div class="SearchBody" @click="searchGoods()">
        <i  class="iconfont icon-sousuo"/>
        <span>搜索商品</span>
    </div>
    <div class="SortTool" v-if="middle">
      <i class="iconfont icon-fenlei2" @click="changeStyle('list')" v-if="btn=='cell'"/>
      <i class="iconfont icon-qiehuan" @click="changeStyle('cell')" v-if="btn=='list'"/>
    </div>
  </div>
</template>
<script>

export default {
  props:["middle"],
  data() {
    return {
      value: "",
      btn:"cell"
    };
  },
  created(){
    this.btn= this.$store.state.system.listStyle;
  },
  methods: {
    onSearch() {

    },
    changeStyle(btnStyle){
      this.btn= btnStyle
      this.$store.commit("LISTSTYLE",btnStyle);
    },
    back(){
     this.$router.go(-1);
    },
    searchGoods(){
      this.$router.push("/pages/search/index");
    }
  }
};
</script>
<style lang="less" scoped>
.SearchWrap{
    background: #fff;
    padding: 9px 6.5px;
    display: flex;
    border-bottom: 1px solid #eee;
    .back{
      width: 30px;
      text-align: center;
      line-height: 30px;
      font-size: 20px;
    }
    .SearchBody{
      border-bottom:0;
      background:#f7f7f7;
      border-radius:25px;
      font-size:16px;
      color:#999;
      height:32px;
      line-height:32px;
      // width: 302px;
      flex: 1 1 auto;
      padding: 0px 10px;
      overflow: hidden;
      i{
        font-size: 20px;
        float: left;
        height: 32px;
        line-height: 32px;
      }
      span{
        font-size: 14px;
        float: left;
        height: 32px;
        line-height: 32px;
      }
    }
    .SortTool{
      width: 30px;
      height: 32px;
      text-align: center;
      i{
        display: block;
        height: 32px;
        line-height: 32px;
        font-size: 28px;
      }
    }

}
</style>